const actions = {
  getSplitIOTreatments: 'GET_SPLITIO_TREATMENTS',
  clearSplitIOTreatments: 'CLEAR_SPLITIO_TREATMENTS',
};

export default actions;
